import React from 'react';
import Link from "next/link";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { policyUpdated } from "../store/actions/acceptPolicy";
import Image from "next/image";



const Footer = ({ showSecFooter }) => {
  const [year, setYear] = useState("");
  const [routeName, setRouteName] = useState(null);
  const [isClient, setIsClient] = useState(false);
  const [hasMounted, setHasMounted] = useState(false);
  const [showPopup, setShowPopup] = useState(true);
  


  const router = useRouter();
  const dispatch = useDispatch();

  const acceptCookies = useSelector(
    (state) => state.acceptPolicy.acceptedPolicy
  );
  
  const policyAgreeHandler = () => {
    Cookies.set("accept-cookie", "true");
    dispatch(policyUpdated(true));
    
    
  };
 

useEffect(() => {
  const timer = setTimeout(() => {
    dispatch(policyUpdated(Cookies.get("accept-cookie") === "true"));
    setHasMounted(true);
    setIsClient(true);
    setRouteName(router.pathname);
    setYear(new Date().getFullYear());
  }, 15000);

  return () => clearTimeout(timer);
}, [router.pathname]);
 const rejectHandler = () => {
    // handle reject logic here
    //setShowPopup(false); // hide after rejecting
    Cookies.set("accept-cookie", "true");
    dispatch(policyUpdated(true));
  };

  const showCookiePolicyHandler = () => {
    if (typeof $ !== "undefined"){
      if (routeName && routeName === "/checkout") {
      jQuery.noConflict();
      $("#showCookiePolicy").modal("show");
    } else {
      $("#showCookiePolicy").modal("show");
    }
    }
    
  };
  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <>
      {/* {isClient && showSecFooter &&  (
        <section className="sec-footer">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-12 app-text">
                <h4 className="text-dark ">
                Browse our menu and order from
                  
                  your phone using the Kilimeals
                  
                  app. Pick up or get it delivered!
                </h4>
                
                <div className="mobile-link-container   mt-5">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.kilimanjaro.kilimeals"
                    target="_blank"
                  >
                  
                    <Image
    src="/images/playstore-btn-red.png"
    alt="Play Store"
    width={127}
    height={35}
    loading="lazy"
/>
                  </a>
                  <a
                    href="https://apps.apple.com/us/app/kilimeals/id1571917847"
                    target="_blank"
                  >
                    
                    <Image
    src="/images/appstore-btn-red.png"
    alt="App Store"
    width={127}
    height={35}
    loading="lazy"
/>
                  </a>
                </div>
              </div>
              <div className="col-md-5 d-lg-block d-none ">
               
                <img
                  className="app-img app-img-1"
                  src="/images/app-1.webp"
                  alt="app"
                  
                />
                <img
                  className="app-img app-img-2"
                  src="/images/app-2.webp"
                  alt="app"
                  
                />
                 
              </div>
            </div>
            
          </div>
         
        </section>
      )} */}
      <section>
      {hasMounted &&
      !acceptCookies && (
        <div className="row p-5 ">
  <div className="col-12 col-lg-3 cookie-popup">
    <div className="px-5 py-4  shadow-lg cookies-wrapper" >
    <div className="d-flex justify-content-between align-items-center mb-3">
  <h6 className=" mb-0">We use cookies...</h6>
  <img
    src="/images/info-circle.svg"
    alt="info-icon"
    className="img-fluid"
    style={{ cursor: "pointer" }}
    width={20}
    height={20}
    onClick={showCookiePolicyHandler}
  />
</div>

      <p>
        We use cookies and various web tracking technologies to personalize
        content and ads for you.
      </p>
     
  <button
    className="btn   mr-3 mt-2 w-100"
    
    onClick={policyAgreeHandler}
  >
      <span className="text">Accept Cookies</span>
  </button>
  <button
    className="btn-white  mt-2 w-100"
  
    onClick={rejectHandler}
  >
      <span className="text">Reject All</span>
  </button>
  


    </div>
  </div>
</div>

      )
     }

      </section>
    
      
      {/* <footer className="footer">
     
        <div className="container">
  <div className="row">
    <div className="col-md-12">
      
      <ul className="navbar-nav flex-row flex-wrap justify-content-center align-items-center footer-links mb-2">
        <li className="nav-item">
          <Link href="/about" target="_blank"><a className="nav-link" target="_blank">About</a></Link>
        </li>
        <li className="nav-item">
          <Link href="/career" target="_blank"><a className="nav-link" target="_blank">Careers</a></Link>
        </li>
        <li className="nav-item">
          <Link href="/contact" target="_blank"><a className="nav-link" target="_blank">Contact</a></Link>
        </li>
        <li className="nav-item" >
          <Link href="/faq" target="_blank"><a className="nav-link" target="_blank">FAQs</a></Link>
        </li>
        <li className="nav-item">
          <Link href="/terms" target="_blank"><a className="nav-link" target="_blank" rel="noopener noreferrer">Terms & Conditions</a></Link>
        </li>
      </ul>

    
      <ul className="navbar-nav flex-row flex-wrap justify-content-center align-items-center footer-links">
        <li className="nav-item">
          <Link href="https://www.instagram.com/kilirestaurant/">
            <a target="_blank" rel="noopener noreferrer" className="social-media">
              <img src="/images/icon/instagram-sm.svg" alt="instagram icon" className="img-fluid" width={50} height={50} />
            </a>
          </Link>
        </li>
        <li className="nav-item">
          <Link href="https://twitter.com/kilirestaurant">
            <a target="_blank" rel="noopener noreferrer" className="social-media">
              <img src="/images/icon/x-sm.svg" alt="x icon" className="img-fluid" width={50} height={50} />
            </a>
          </Link>
        </li>
        <li className="nav-item">
          <Link href="http://www.facebook.com/kilimanjarorestaurants">
            <a target="_blank" rel="noopener noreferrer" className="social-media">
              <img src="/images/icon/facebook-sm.svg" alt="facebook icon" className="img-fluid" width={50} height={50} />
            </a>
          </Link>
        </li>
        <li className="nav-item">
          <Link href="mailto:info@sundryfood.com">
            <a target="_blank" rel="noopener noreferrer" className="social-media">
              <img src="/images/icon/mail-sm.svg" alt="mail icon" className="img-fluid mail-icon" width={50} height={50} />
            </a>
          </Link>
        </li>
      </ul>
    </div>
  </div>

  <div className="col-md-12 text-center mt-3">
    <p className="h-100 d-flex justify-content-center align-items-center text-secondary">
      &copy; {year} Kilimanjaro Restaurants. All rights reserved.
    </p>
  </div>
</div>
      </footer> */}
      
   <footer className="footer">
  <div className="container">
    <div className="row footer-top">
      {/* Brand column */}
      <div className="col-12 col-lg-auto footer-brand">
        <Link href="/">
          <a className="footer-brand__logo">
            <img
              src="/images/icon/kilimanjaro-logo.svg"
              alt="Kilimanjaro Restaurants"
              className="img-fluid"
            />
          </a>
        </Link>
        <p className="footer-brand__tagline">
          <b>Kilimanjaro Restaurants;</b> Good food brings people together. Find your favourites on our menu and enjoy them your way, whether you’re dining in, picking up, or ordering for delivery.
        </p>
      </div>

      {/* Link columns group — pushed to the right on desktop */}
      <div className="col-12 col-lg-auto footer-links-group">
        <div className="footer-col">
          <h6 className="footer-col__title">Explore</h6>
          <ul className="footer-col__list">
            <li>
              <Link href="/order">
                <a>Order</a>
              </Link>
            </li>
            <li>
              <Link href="/#">
                <a>Menu</a>
              </Link>
            </li>
            <li>
              <Link href="/locations">
                <a>Locations</a>
              </Link>
            </li>
            <li>
              <Link href="/giftcard">
                <a>Gift Cards</a>
              </Link>
            </li>
            <li>
              <Link href="/wallet">
                <a>e-Wallet</a>
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-col">
          <h6 className="footer-col__title">Kilimanjaro</h6>
          <ul className="footer-col__list">
            <li>
              <Link href="/about" target="_blank">
                <a target="_blank">About Us</a>
              </Link>
            </li>
            <li>
              <Link href="/career" target="_blank">
                <a target="_blank">Careers</a>
              </Link>
            </li>
            <li>
              <Link href="/contact" target="_blank">
                <a target="_blank">Contact Us</a>
              </Link>
            </li>
            <li>
              <Link href="/blog">
                <a>Blog</a>
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-col">
          <h6 className="footer-col__title">Help</h6>
          <ul className="footer-col__list">
            <li>
              <Link href="/faq" target="_blank">
                <a target="_blank">FAQs</a>
              </Link>
            </li>
            <li>
              <Link href="/terms" target="_blank">
                <a target="_blank" rel="noopener noreferrer">
                  Terms & Conditions
                </a>
              </Link>
            </li>
          </ul>

          <h6 className="footer-col__title footer-col__title--social">
            Follow Us
          </h6>
          <ul className="footer-social">
            <li>
              <Link href="https://www.instagram.com/kilirestaurant/">
                
                 <a target="_blank"
                  rel="noopener noreferrer"
                  className="social-media"
                  aria-label="Instagram"
                >
                  <img
                    src="/images/icon/instagram-sm-red.svg"
                    alt="instagram icon"
                    className="img-fluid"
                    width={50}
                    height={50}
                  />
                </a>
              </Link>
            </li>
            <li>
              <Link href="http://www.facebook.com/kilimanjarorestaurants">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-media"
                  aria-label="Facebook"
                >
                  <img
                    src="/images/icon/facebook-sm-red.svg"
                    alt="facebook icon"
                    className="img-fluid"
                    width={50}
                    height={50}
                  />
                </a>
              </Link>
            </li>
            <li>
              <Link href="https://twitter.com/kilirestaurant">
                
                 <a target="_blank"
                  rel="noopener noreferrer"
                  className="social-media"
                  aria-label="X (Twitter)"
                >
                  <img
                    src="/images/icon/x-sm-red.svg"
                    alt="x icon"
                    className="img-fluid"
                    width={50}
                    height={50}
                  />
                </a>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div className="row footer-bottom">
      <div className="col-12 text-center">
        <p className="mb-0">
          &copy; {year} Kilimanjaro Restaurants. All rights reserved.
        </p>
      </div>
    </div>
  </div>
</footer>

     
    </>
  );
};

export default Footer;